import React, { useEffect, useRef } from "react";
import PhoneNumberInput from "../Commons/PhoneNumberInput/PhoneNumberInput";
import { VerifyPhoneNumberWidgetProps } from "./type";
import ChatbotImg from "../../assets/imgs/ai-chat-logo.svg";

const VerifyPhoneNumberWidget: React.FC<VerifyPhoneNumberWidgetProps> = ({
  phoneNumber,
  handlePhoneNumberChange,
  isValid,
  handleSendSMS,
  errorsPhoneNumber,
  setErrorsPhoneNumber
}) => {
  const inputRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseDown = (e: MouseEvent) => {
      if (inputRef.current && !inputRef.current.contains(e.target as Node)) {
        e.preventDefault();
      }
    };
    document.addEventListener("mousedown", handleMouseDown, true);
    return () => document.removeEventListener("mousedown", handleMouseDown, true);
  }, []);

  const handleOnChange = (e: string) => {
    handlePhoneNumberChange(e || "");
    setErrorsPhoneNumber(null);
  };

  return (
    <div className="w-full flex flex-col items-center mt-36 h-screen text-center overflow-hidden">
      <div className="sm:w-1/2 sm:px-10 w-full flex flex-col items-center min-h-[350px]">
        <div className="flex flex-col items-center space-y-3">
          <img src={ChatbotImg} alt="ChatbotImg" className="w-[44px] h-[34px]" />
          <div className="font-bold text-white text-[32px]">
            Your phone number
          </div>
        </div>

        <div className="mt-10 sm:ml-10 w-full flex flex-col items-center" ref={inputRef}>
          <PhoneNumberInput value={phoneNumber} onChange={handleOnChange} />
          {!isValid && (
            <p className="text-red-500 mt-4">Please enter a valid phone number.</p>
          )}
          {(errorsPhoneNumber &&  isValid) && (
            <p className="text-red-500 mt-4">{errorsPhoneNumber}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyPhoneNumberWidget;
